<template>
  <CRow>
    <CCol col="12" xl="8">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          Decorations
          <CButton size="sm" style="float:right;" color="success" @click="addModal = true">Add Decoration</CButton>
        </CCardHeader>
        <CCardBody>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CDataTable
            :items="items"
            :fields="fields"
            column-filter
            table-filter
            :items-per-page="10"
            pagination
          >
          <template #edit="{item}">
            <td>
              <CButton size="sm" color="primary" @click="edit( item.decoration_id )">Edit</CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>

      <CModal
        title="Add Decoration"
        :show.sync="addModal"
      >
        <CForm>
          <CInput
            :lazy="false"
            :value.sync="form.decoration_name"
            placeholder="Decoration Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="form.customer_number"
            placeholder="Customer Number"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="form.min_quantity"
            placeholder="Min Quantity"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="form.cost"
            placeholder="Cost"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="form.lead_time"
            placeholder="Lead Time"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
        </CForm>
        <template #footer>
          <CButton @click="addModal = false, reset()" color="danger">Cancel</CButton>
          <CButton @click="add()" color="success">Add</CButton>
        </template>
      </CModal>

      <CModal
        title="Edit Program"
        :show.sync="editModal"
      >
        <CForm v-if="editForm">
          <CInput
            :lazy="false"
            :value.sync="editForm.decoration_name"
            placeholder="Decoration Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
        </CForm>
        <template #footer>
          <CButton @click="editModal = false, resetEdit()" color="danger">Cancel</CButton>
          <CButton @click="save()" color="success">Save</CButton>
        </template>
      </CModal>
    </CCol>
  </CRow>
</template>

<script>
var methods = {}

methods.getData = function () {
  let self = this
  axios.get( this.$apiAdress + '/api/decorations?token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    self.items = response.data
  }).catch(function (error) {
    console.log(error)
  });
}

methods.reset = function () {
  this.form = {name: ''}
}

methods.resetEdit = function () {
  this.editModal = null
}

methods.edit = function (val) {
  this.$router.push({ path: '/decorations/' + val + '/edit' })
}

methods.save = function () {
  let self = this
  axios.post(this.$apiAdress + '/api/decorations/save?token=' + localStorage.getItem('api_token'), self.editForm)
  .then(function (response) {

  }).catch(function (error) {
    console.log(error)
  })
}

methods.add = function () {
  let self = this;
  axios.post(   this.$apiAdress + '/api/decorations/store?token=' + localStorage.getItem("api_token"),
    self.form
  )
  .then(function (response) {
      console.log(response)
      self.items.push(response.data)
      self.form = {style_name: ''}
      self.addModal = false
  }).catch(function (error) {
      // if(error.response.data.message == 'The given data was invalid.'){
      //   self.message = '';
      //   for (let key in error.response.data.errors) {
      //     if (error.response.data.errors.hasOwnProperty(key)) {
      //       self.message += error.response.data.errors[key][0] + '  ';
      //     }
      //   }
      //   self.showAlert();
      // }
  });
}

methods.getForm = function () {
  return {
    decoration_name: '',
    customer_number: '',
    min_quantity: '',
    cost: '',
    lead_time: '',
  }
}

export default {
  name: 'Decorations',
  data() {
    return {
      items: [],
      fields: ['decoration_name', 'customer_number', 'min_quantity', 'cost', 'edit'],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      addModal: false,
      form: this.getForm(),
      editForm: null,
      editModal: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  methods: methods,
  mounted: function(){
    this.getData()
  }
}
</script>
